import { render } from "./OrderCreateLead.vue?vue&type=template&id=4ae246fc"
import script from "./OrderCreateLead.vue?vue&type=script&lang=js"
export * from "./OrderCreateLead.vue?vue&type=script&lang=js"

import "./OrderCreateLead.vue?vue&type=style&index=0&id=4ae246fc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__